// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"c3de1097","69":"274fcbac","242":"20d00b03","667":"f3756dcc","977":"240addac","998":"3b15132d"}[chunkId] + ".chunk.js";
};